<template>
  <div v-if="!isNarrowWidthDevice" class="tool-search-wrapper">
    <p class="title">{{ $t('comparisonFeature.tools.selectionModalTitle') }}</p>
    <input
      type="text"
      :placeholder="$t('comparisonFeature.tools.selectionInputPlaceholder')"
      class="form-control"
      v-model.trim="toolQuery"
    />
  </div>
  <div v-else class="tool-search-wrapper--narrow-width-device">
    <p class="title">
      <span
        v-show="stage === 1"
        class="icon go-back"
        @click="handleModalStageChange(0)"
      >
        <fa icon="chevron-left"></fa>
      </span>
      <span>
        {{
          stage === 0
            ? $t('comparisonFeature.tools.selectionCategoryModalOnMobile')
            : $t('comparisonFeature.tools.selectionToolsModalOnMobile')
        }}
      </span>
    </p>
    <input
      type="text"
      :placeholder="$t('comparisonFeature.tools.selectionInputPlaceholder')"
      class="form-control"
      v-model.trim="toolQuery"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
// import TOOLS from '../../constants/tools';

export default {
  props: ['stage'],
  data() {
    return {
      toolQuery: this.comparisonToolQuery,
    };
  },

  computed: {
    ...mapState([
      'comparisonToolList',
      'comparisonToolQuery',
      'isNarrowWidthDevice',
    ]),
  },

  methods: {
    ...mapMutations([
      'updateComparisonToolCategory',
      'updateComparisonToolQuery',
    ]),

    handleModalStageChange(stage) {
      this.updateComparisonToolCategory('');
      this.$emit('onModalStageChange', stage);
    },
  },

  watch: {
    toolQuery() {
      if (this.toolQuery) {
        if (this.stage === 0) this.handleModalStageChange(1);

        this.updateComparisonToolCategory('All');
      }

      this.updateComparisonToolQuery(this.toolQuery);
    },
  },

  mounted() {},
};
</script>

<style scoped lang="scss">
.tool-search-wrapper {
  height: 100%;
  margin: 1rem;
  margin-bottom: 0.5rem;
  padding: 0;
}
.title {
  margin: 0;
  margin-bottom: 0.25rem;
  font-size: 1.2rem;
  font-weight: 900;
}

.tool-search-wrapper--narrow-width-device {
  position: relative;
  margin: 0 3rem;
  padding-top: 1rem;

  .icon {
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    color: $text-light-blue;
  }
  .go-back {
    position: absolute;
    left: -3rem;
    top: 0.5rem;
  }
}
</style>
